import { render, staticRenderFns } from "./ShareIndex.vue?vue&type=template&id=2acade44&scoped=true&"
import script from "./ShareIndex.vue?vue&type=script&lang=js&"
export * from "./ShareIndex.vue?vue&type=script&lang=js&"
import style0 from "./ShareIndex.vue?vue&type=style&index=0&id=2acade44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acade44",
  null
  
)

export default component.exports